import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import withStylyze from 'modules/shell/hoc/withStylyze';
import withUserGroupMembershipBOH from 'modules/shell/hoc/withUserGroupMembershipBOH';

import { compose } from 'redux';
import { graphql } from '@apollo/client/react/hoc';
import { connect } from 'react-redux';

import GlobalNav from './GlobalNav';
import styles from './GlobalNav.styles';
import { getMessageNotificationForAssociate, getNotificationCountForAssociate } from '../../../../graphQL/query';

const mapStateToProps = ({ user, globalNavigation, userGroups: { activeADGroup } }) => ({
  user: user.data,
  isVisible: globalNavigation.isVisible,
  activeADGroup,
});

export default compose(
  connect(mapStateToProps),
  graphql(getMessageNotificationForAssociate, {
    options: ({ user, activeADGroup }) => ({
      fetchPolicy: 'no-cache',
      variables: {
        associateId: user?.employeeNumber,
      },
      context: {
        headers: {
          'X-NMG-Group': activeADGroup,
        },
      },
    }),
    props: (props) => ({
      notifications: props.data.getMessageNotificationForAssociate,
      refetchMessageCount: props.data.refetch,
    }),
  }),
  graphql(getNotificationCountForAssociate, {
    options: ({ user, activeADGroup }) => ({
      fetchPolicy: 'no-cache',
      variables: {
        associateId: user?.employeeNumber,
      },
      context: {
        headers: {
          'X-NMG-Group': activeADGroup,
        },
      },
    }),
    props: (props) => ({
      alertNotifications: props.data.getNotificationCountForAssociate || [],
    }),
  }),
  withRouter,
  withStylyze,
  withStyles(styles),
  withUserGroupMembershipBOH(),
)(GlobalNav);
